"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GridduckSubscription extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gridduckSubscription';
        this._billingCycleAnchor = initParams.billing_cycle_anchor;
        this._items = (0, util_1.camelArray)(initParams.items);
    }
    set billingCycleAnchor(value) {
        console.error('Do not set objects this way');
    }
    get billingCycleAnchor() {
        return this._billingCycleAnchor;
    }
    set items(value) {
        console.error('Do not set objects this way');
    }
    get items() {
        return this._items;
    }
}
exports.default = GridduckSubscription;
//# sourceMappingURL=gridduckSubscription.js.map